import AdultGuardianWorkspace from "../../../../components/adult/guardian/AdultGuardianWorkspace";

const AdultGuardianMyTeensPage = () => {
  return <AdultGuardianWorkspace />;
};

export default AdultGuardianMyTeensPage;
